import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ApplicationSubType, Inspection } from '../../shared/models';
import { StorageAccessor } from '../../shared/services/storage-accessor';

@Component({
    selector: 'inspection-model-list-table',
    templateUrl: './list.component.html',
    standalone: false
})
export class InspectionModelListComponent {
  @Input() models: Inspection[];
  @Input() query = '';
  @Input() selectable = false;
  @Input() directionPersistenceName = 'InspectionModelListComponentDirection';
  @Input() orderByFieldNamePersistenceName = 'InspectionModelListComponentOrderBy';
  @Input() footer = false;
  @Output() toggleSelectInspectionModel: EventEmitter<any> = new EventEmitter();
  selection: any = {};
  orderByFieldName = '';
  direction = 'asc';
  loading: Boolean = true;
  applicationSubType = ApplicationSubType;
  errorMessage: string;

  constructor(protected storageAccessor: StorageAccessor) {

    this.orderByFieldName = this.storageAccessor.getItemFromSession(this.orderByFieldNamePersistenceName);

    if (!this.orderByFieldName) {
      this.orderByFieldName = 'name';
    }

    this.direction = this.storageAccessor.getItemFromSession(this.directionPersistenceName);

    if (!this.direction) {
      this.direction = 'asc';
    }
  }

  public selectInspectionModel(inspection: Inspection) {
    this.toggleSelectInspectionModel.emit(inspection);
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
    this.storageAccessor.setItemToSession(this.orderByFieldNamePersistenceName, this.orderByFieldName);
    this.storageAccessor.setItemToSession(this.directionPersistenceName, this.direction);
  }
}
